<template>
  <div class="page-container">
    <el-card class="card-top" shadow="hover">
      <div class="card-actions">
        <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">新增教练</el-button>
      </div>
    </el-card>
    <el-card class="card-table" shadow="hover">
      <el-table :data="coaches" border stripe style="width: 100%" size="small" height="600px">
        <el-table-column prop="name" label="姓名" align="center" />
        <el-table-column prop="gender" label="性别" align="center">
          <!-- <template slot-scope="scope">
            {{ scope.row.gender === 'MALE' ? '男' : '女' }}
          </template> -->
        </el-table-column>
        <el-table-column prop="phone" label="手机号" align="center" />
        <el-table-column prop="idCard" label="身份证号" align="center" />
        <el-table-column prop="photoUrl" label="教练照片" align="center" width="120">
          <template slot-scope="scope">
            <div class="photo-cell">
              <el-image
                v-if="scope.row.photoUrl"
                :src="scope.row.photoUrl"
                :preview-src-list="[scope.row.photoUrl]"
                fit="cover"
                class="table-photo"
              />
              <span v-else style="color: #ccc;">无</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="关联项目" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.vehicles && scope.row.vehicles.length">
              {{ scope.row.vehicles.map(v => v.description).join(', ') }}
            </span>
            <span v-else style="color: #ccc;">无</span>
          </template>
        </el-table-column>
        <el-table-column label="所属区域" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.regions && scope.row.regions.length">
              {{ scope.row.regions.map(r => r.name).join(', ') }}
            </span>
            <span v-else style="color: #ccc;">无</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="220">
          <template slot-scope="scope">
            <el-button type="text" style="color: #67C23A" size="small"
              @click="openVehicleDialog(scope.row)">关联项目</el-button>
            <el-button type="text" style="color: #E6A23C" size="small"
              @click="openRegionDialog(scope.row)">关联区域</el-button>
            <el-button type="text" style="color: #409EFF" size="small"
              @click="editCoach(scope.row)">编辑</el-button>
            <el-button type="text" style="color: #F56C6C" size="small" @click="deleteCoach(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-pagination">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="size" :current-page="page"
          @current-change="handlePageChange" />
      </div>
    </el-card>

    <el-dialog :title="isEdit ? '编辑教练' : '新增教练'" :visible.sync="visible" width="420px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="90px" size="small">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" size="small" />
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="form.gender" size="small">
            <el-radio label="男" size="small">男</el-radio>
            <el-radio label="女" size="small">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号" size="small" />
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="form.idCard" placeholder="请输入身份证号" size="small" />
        </el-form-item>
        <el-form-item label="教练照片" prop="coachPhoto">
          <el-upload class="upload-demo" action="" list-type="picture-card" :show-file-list="false"
            :before-upload="handleBeforeUpload" :on-change="file => handleFileChange(file, 'coachPhoto')">
            <div v-if="form.coachPhoto" class="avatar-wrapper">
              <img :src="form.coachPhoto" class="avatar" />
              <i class="el-icon-close close-icon" @click.stop="clearCoachPhoto"></i>
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="车辆关联管理" :visible.sync="vehicleDialogVisible" width="420px" :close-on-click-modal="false">
      <el-form :model="vehicleForm" ref="vehicleFormRef" label-width="90px" size="small">
        <el-form-item label="车辆管理" prop="vehicleIds">
          <el-select v-model="vehicleForm.vehicleIds" multiple filterable placeholder="请选择车辆" style="width: 100%">
            <el-option v-for="item in vehicleOptions" :key="item.id"
              :label="item.description" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="vehicleDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleVehicleBind" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="区域关联管理" :visible.sync="regionDialogVisible" width="420px" :close-on-click-modal="false">
      <el-form :model="regionForm" ref="regionFormRef" label-width="90px" size="small">
        <el-form-item label="区域管理" prop="regionIds">
          <el-select v-model="regionForm.regionIds" multiple filterable placeholder="请选择区域" style="width: 100%">
            <el-option v-for="item in regionOptions" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="regionDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleRegionBind" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CoachManage',
  data() {
    return {
      coaches: [],
      total: 0,
      page: 1,
      size: 10,
      visible: false,
      isEdit: false,
      form: {
        name: '',
        gender: '',
        phone: '',
        idCard: '',
        photoUrl: null,
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        idCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
        coachPhoto: [{ required: true, message: '请上传教练照片', trigger: 'change' }]
      },
      vehicleDialogVisible: false,
      vehicleForm: {
        vehicleIds: []
      },
      vehicleOptions: [],
      currentCoach: null,
      regionDialogVisible: false,
      regionForm: {
        regionIds: []
      },
      regionOptions: [],
      currentCoachForRegion: null,
    }
  },
  methods: {
    openAddDialog() {
      this.isEdit = false;
      this.form = {
        name: '',
        gender: '',
        phone: '',
        idCard: '',
        coachPhoto: '',
      };
      this.visible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    async editCoach(row) {
      console.log("🚀 ~ editCoach ~ row:", row)
      this.isEdit = true;
      this.visible = true;
      try {
        const res = await axios.get(`/api/coaches/${row.id}`);
        const data = res.data;
        console.log("🚀 ~ editCoach ~ res:", res)
        this.form = {
          name: data.name || '',
          gender: data.gender === 'MALE' ? '男' : '女',
          phone: data.phone || '',
          idCard: data.idCard || '',
          coachPhoto: data.photoUrl || '',
          id: data.id || ''
        };
      } catch (e) {
        this.$message.error('获取教练详情失败');
        this.form = {
          name: '',
          gender: '',
          phone: '',
          idCard: '',
          coachPhoto: '',
        };
      }
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    async deleteCoach(row) {
      try {
        const res = await axios.delete(`/api/coaches/${row.id}`);
        if (res.data && res.data.code && res.data.code !== 200) {
          this.$message.error(res.data.message || '删除失败');
        } else {
          this.$message.success('删除成功');
          this.fetchCoaches();
        }
      } catch (e) {
        this.$message.error((e.response && e.response.data && e.response.data.message) ? e.response.data.message : '删除失败');
      }
    },
    handleBeforeUpload() {
      // 阻止自动上传
      return false;
    },
    async uploadCoachPhoto(file) {
      const formData = new FormData();
      formData.append('file', file);
      // 代理已配置，直接用 /api/upload/image
      const res = await axios.post('/api/upload/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.data.fileName) {
        return res.data.previewUrl;
      } else {
        this.$message.error(res.data.error);
      }

    },
    async handleFileChange(file, type) {
      this.form[type] = file.raw;
      // 上传图片并获取URL
      try {
        this.form.coachPhoto = await this.uploadCoachPhoto(file.raw);
        console.log("🚀 ~ handleFileChange ~  this.form.coachPhoto:", this.form.coachPhoto)

        // 如果 url 为 undefined（上传失败），不做任何处理，保留原图片
      } catch (e) {
        this.$message.error('图片上传失败');
        // 不清空当前图片，保留原有图片
      }
    },
    clearCoachPhoto() {
      this.form.coachPhoto = '';
    },
    async handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        const genderMap = { '男': 'MALE', '女': 'FEMALE' };
        const params = {
          name: this.form.name,
          idCard: this.form.idCard,
          gender: genderMap[this.form.gender] || '',
          phone: this.form.phone,
          photoUrl: this.form.coachPhoto
        };
        try {
          let nowId = '';
          if (this.isEdit && this.form.id) {
            const res = await axios.put(`/api/coaches/${this.form.id}`, params);
            if (res.data && res.data.code && res.data.code !== 200) {
              this.$message.error(res.data.message || '编辑失败');
              return;
            }
            nowId = res.data.id;
          } else {
            const res = await axios.post('/api/coaches', params);
            if (res.data && res.data.code && res.data.code !== 200) {
              this.$message.error(res.data.message || '新增失败');
              return;
            }
            nowId = res.data.id;
            console.log("🚀 ~ this.$refs.formRef.validate ~ res:", res)
          }
          if (nowId) {
            this.$message.success(`${this.isEdit ? '编辑' : '新增'}教练成功`);
          } else {
            this.$message.error(`${this.isEdit ? '编辑' : '新增'}教练失败`);
          }
          this.visible = false;
          this.isEdit = false;
          this.page = 1;
          this.fetchCoaches();
        } catch (e) {
          this.$message.error((e.response && e.response.data && e.response.data.message) ? e.response.data.message : `${this.isEdit ? '编辑' : '新增'}教练失败`);
        }
      });
    },
    async fetchCoaches() {
      try {
        const res = await axios.get('/api/coaches/search', {
          params: {
            page: this.page,
            size: this.size
          }
        });
        this.coaches = res.data.content || [];
        this.total = res.data.totalElements || 0;
      } catch (e) {
        this.$message.error('获取教练列表失败');
      }
    },
    handlePageChange(val) {
      this.page = val;
      this.fetchCoaches();
    },
    async openVehicleDialog(row) {
      this.currentCoach = row;
      this.vehicleDialogVisible = true;
      // 获取车辆列表
      try {
        const res = await axios.get('/api/vehicles', { params: { page: 1, size: 100 } });
        this.vehicleOptions = res.data || [];
      } catch (e) {
        this.$message.error('获取车辆列表失败');
        this.vehicleOptions = [];
      }
      // 回显已关联车辆
      this.vehicleForm.vehicleIds = Array.isArray(row.vehicles)
        ? row.vehicles.map(v => v.id)
        : [];
    },
    async handleVehicleBind() {
      if (!this.vehicleForm.vehicleIds || this.vehicleForm.vehicleIds.length === 0) {
        this.$message.error('请选择要关联的车辆');
        return;
      }
      try {
        const res = await axios.post('/api/coach-vehicles/batch-assign', {
          coachId: this.currentCoach.id,
          vehicleIds: this.vehicleForm.vehicleIds
        });
        if (res.data && res.data.code && res.data.code !== 200) {
          this.$message.error(res.data.message || '车辆关联失败');
        } else {
          this.$message.success('车辆关联成功');
          this.vehicleDialogVisible = false;
          this.fetchCoaches();
        }
      } catch (e) {
        this.$message.error((e.response && e.response.data && e.response.data.message) ? e.response.data.message : '车辆关联失败');
      }
    },
    async openRegionDialog(row) {
      this.currentCoachForRegion = row;
      this.regionDialogVisible = true;
      // 获取区域列表
      try {
        const res = await axios.get('/api/regions');
        this.regionOptions = res.data || [];
      } catch (e) {
        this.$message.error('获取区域列表失败');
        this.regionOptions = [];
      }
      // 回显已关联区域
      this.regionForm.regionIds = Array.isArray(row.regions)
        ? row.regions.map(r => r.id)
        : [];
    },
    async handleRegionBind() {
      if (!this.regionForm.regionIds || this.regionForm.regionIds.length === 0) {
        this.$message.error('请选择要关联的区域');
        return;
      }
      try {
        const res = await axios.post('/api/coaches/batch-assign-region', {
          coachId: this.currentCoachForRegion.id,
          regionIds: this.regionForm.regionIds
        });
        if (res.data && res.data.code && res.data.code !== 200) {
          this.$message.error(res.data.message || '区域关联失败');
        } else {
          this.$message.success('区域关联成功');
          this.regionDialogVisible = false;
          this.fetchCoaches();
        }
      } catch (e) {
        this.$message.error((e.response && e.response.data && e.response.data.message) ? e.response.data.message : '区域关联失败');
      }
    },
  },
  mounted() {
    this.fetchCoaches();
    document.body.classList.add('coach-viewer-medium');
  },
  beforeDestroy() {
    document.body.classList.remove('coach-viewer-medium');
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 24px 18px 0 18px;
  background: #f6f8fa;
  min-height: 100%;
}

.card-top {
  margin-bottom: 18px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.card-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.card-table {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.el-table {
  font-size: 15px;
  border-radius: 6px;
  overflow: hidden;
}

.table-pagination {
  margin-top: 18px;
  text-align: right;
}

.upload-demo {
  display: flex;
  flex-direction: column;
}

.avatar-wrapper {
  position: relative;
  display: inline-block;
}

.avatar {
  width: 148px;
  height: 148px;
  display: block;
  object-fit: cover;
  border-radius: 6px;
}

.close-icon {
  position: absolute;
  top: 2px;
  right: 2px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  z-index: 2;
  padding: 2px;
  transition: background 0.2s;
}

.close-icon:hover {
  background: rgba(255, 0, 0, 0.7);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  line-height: 100px;
  text-align: center;
}

.table-photo {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
  cursor: zoom-in;
}

.photo-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.dialog-footer {
  text-align: right;
}
</style>

<style lang="scss">
/* 仅教练管理页面：缩小图片预览初始尺寸 */
.coach-viewer-medium .el-image-viewer__img {
  height: 50vh;
  width: auto;
  max-height: 70vh;
}
</style>